import { MapPinIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useMemo } from 'react';

type DistancePillVariant = 'primary' | 'subtle';

const variantClasses: Record<DistancePillVariant, { wrapper: string; label: string }> = {
  primary: {
    wrapper: 'w-fit bg-primary-active text-white',
    label: 'text-nowrap',
  },
  subtle: {
    wrapper: 'bg-brandBlue-200 text-brandBlue-800',
    label: '',
  },
};

export const DistancePill: React.FC<{ distance: number; variant?: DistancePillVariant }> = ({ distance, variant = 'primary' }) => {
  const distanceText = useMemo(() => {
    if (typeof distance !== 'number') return null;
    if (distance < 1000) return `${distance} m`;
    return `${(distance / 1000).toFixed(1)} km`;
  }, [distance]);

  const classes = useMemo(() => variantClasses[variant], [variant]);

  if (!distanceText) return null;

  return (
    <div className={clsx('flex items-center gap-1 rounded-full px-2 py-0.5', classes.wrapper)}>
      <MapPinIcon className="h-auto w-3" />
      <span className={clsx('text-xs font-medium', classes.label)}>{distanceText}</span>
    </div>
  );
};
